<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >
      <v-form
        ref="form"
        v-model="valid"
        :lazy-validation="true"
        autocomplete="off"
      >
        <v-card>
          <v-card-title>
            <span class="headline primary--text font-weight-bold">Modifica Nota</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editItem.title"
                    label="Titolo*"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="editItem.priority"
                    :items="priorities"
                    label="Priorità*"
                    item-text="text"
                    item-value="value"
                    :rules="[rules.required]"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="editItem.body"
                    label="Descrizione*"
                    :rules="[rules.required]"
                    required
                  ></v-textarea>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="true"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="editItem.deadline"
                        label="Deadline"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="editItem.deadline"
                      no-title
                      scrollable
                      actions
                      locale="it-IT"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="editItem.deadline = null"
                      >Rimuovi</v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="menu = false"
                      >OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-select
                    v-model="editItem.assignee"
                    :items="users"
                    label="Assegnatario"
                    item-text="text"
                    item-value="value"
                  ></v-select>
                </v-col>
              </v-row>
              <small>*campo obbligatorio.</small>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="edit"
            >Salva</v-btn>
            <v-btn
              color="primary"
              @click="dismiss"
            >Annulla</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'Edit',
    props: {
      dialog: { type: Boolean, default: false },
      users: { type: Array, default: () => [] },
      priorities: { type: Array, default: () => [] },
      item: { type: Object, default: () => { } }
    },

    data() {
      return {
        menu: false,
        valid: false,
        editItem: {},
        editPriorities: [],
        rules: {
          required: (value) => !!value || 'Campo obbligatorio.',
        },
      }
    },

    methods: {
      ...mapActions(['editNote']),

      dismiss() {
        this.$emit('dismiss')
      },

      edit() {
        if (this.$refs.form.validate()) {
          this.editNote(this.editItem).then((status) => {
            if (status) {
              this.$emit('edit')
            }
          })
        }
      },
    },

    watch: {
      item(val) {
        val.priority = val.priority.toString()
        this.editItem = Object.assign({}, val)
      }
    },
  }
</script>

<style></style>
